/** Format classes for type display (e.g. whitespace). */
export function getTypeFormatClasses(fieldType: string): string {
  if (fieldType === 'array' || fieldType === 'object') {
    return 'whitespace-nowrap';
  }
  return '';
}

/** Color classes for pill indicator (small dot). */
export function getTypeColorClasses(fieldType: string): string {
  const colorMap: Record<string, string> = {
    string: 'bg-blue-500',
    number: 'bg-green-500',
    boolean: 'bg-purple-500',
    timestamp: 'bg-orange-500',
    array: 'bg-yellow-500',
    object: 'bg-gray-500',
    null: 'bg-gray-400',
    reference: 'bg-indigo-500',
    geopoint: 'bg-pink-500',
    bytes: 'bg-teal-500',
    vector: 'bg-cyan-500',
    unknown: 'bg-gray-600',
  };
  return colorMap[fieldType] ?? 'bg-gray-500';
}

/** Badge background/text classes for type label. */
export function getTypeBadgeClasses(fieldType: string): string {
  const colorMap: Record<string, string> = {
    string: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
    number: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
    boolean: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
    timestamp: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
    array: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
    object: 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200',
    null: 'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400',
    reference: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-200',
    geopoint: 'bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-200',
    bytes: 'bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-200',
    vector: 'bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-200',
    unknown: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
  };
  return colorMap[fieldType] ?? 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
}
